import * as React from "react";
import { Avatar, Button, Flex, Image, Segment, Text } from "@fluentui/react-northstar";
import { withTranslation, WithTranslation } from "react-i18next";
import { CommonHelper } from '../../../helpers/common-helper';

// @ts-ignore
import '../../../styles/govbr.css';

interface IQueueWelcomeProps extends WithTranslation {
    botWriting: boolean;
    appConfigs: any;
    appSettings: any;
    meetingData: any;
    meetingQueueData: any;
    daysOfWeekLocale: any;
    getAuthUrl: Function;
    logout: Function;
    loggedIn: boolean;
    userProfile: any;
}

const QueueWelcomeCard: React.FunctionComponent<IQueueWelcomeProps> = props => {
    const localize = props.t;

    return (
        <React.Fragment>
            {props.meetingQueueData?.Schedule ?
                <Flex gap="gap.large" className="firstCard">
                    <Avatar icon={<Image src="/images/logo.png" />} />
                    <Image hidden={!props.botWriting} className="typing" src="/images/typing.gif" />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting}
                            className="dialog1"
                            color="brand"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text weight="bold" size="large" content={localize("BemVindo")} />

                                    <Flex hAlign="center" className="welcome-queue">
                                        {props.appConfigs && props.appConfigs.imgWelcome != "" &&
                                            <Flex.Item align="center" className="welcome">
                                                <Image src={props.appConfigs.imgWelcome} />
                                            </Flex.Item>
                                        }

                                        {props.appConfigs && props.appConfigs.imgWelcome == "" &&
                                            <Flex.Item align="center" className="welcome">
                                                <Image styles={{ height: "22rem", margin: "2rem 0" }} src="/images/welcome-scheduled.svg" />
                                            </Flex.Item>
                                        }
                                    </Flex>

                                    <Flex gap="gap.medium" column>
                                        <Flex gap="gap.smaller">
                                            <Text
                                                styles={{ marginRight: '0.4rem !important' }}
                                                weight="light"
                                                size="medium"
                                                content={
                                                    <React.Fragment>
                                                        <div>{localize("VoceEsta")}: <span style={{ fontWeight: 'bold' }}>{props.meetingData.name}</span></div>
                                                    </React.Fragment>}
                                            />
                                        </Flex>

                                        {props.meetingData.descricao &&
                                            <Flex gap="gap.smaller">
                                                <Text
                                                    styles={{ marginRight: '0.4rem !important', whiteSpace: 'pre-line' }}
                                                    weight="light" size="medium"
                                                    content={props.meetingData.descricao}
                                                />
                                            </Flex>
                                        }

                                        <Flex gap="gap.smaller" column>
                                            <Text styles={{ marginBottom: '0px !important' }} weight="light" size="medium" content={`Seu atendimento está agendado.`} />
                                            <Text weight="light" size="medium" content={`Acesse com sua conta gov.br no botão abaixo!`} />
                                        </Flex>
                                    </Flex>

                                    <Flex gap="gap.small">
                                        <button hidden={props.loggedIn} onClick={() => props.getAuthUrl()} className="br-sign-in small primary mt-3 mt-sm-0 ml-sm-3" style={{ fontSize: "14px" }} type="button">
                                            <i style={{ fontSize: "14px" }} className="fas fa-user" aria-hidden="true"></i>Entrar com&nbsp;<span className="text-black">gov.br</span>
                                        </button>

                                        {props.appSettings && props.appSettings.ajudaComoFunciona &&
                                            <Button content={localize("ComoFunciona")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaComoFunciona), "_blank")} />
                                        }

                                        {props.appSettings && props.appSettings.ajudaPerguntasFrequentes &&
                                            <Button content={localize("PerguntasFrequentes")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaPerguntasFrequentes), "_blank")} />
                                        }
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
                :
                <Flex gap="gap.large" className="firstCard">
                    <Avatar icon={<Image src="/images/logo.png" />} />
                    <Image hidden={!props.botWriting} className="typing" src="/images/typing.gif" />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting}
                            className="dialog1"
                            color="brand"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text weight="bold" size="large" content={localize("BemVindo")} />

                                    <Flex hAlign="center" className="welcome-queue">
                                        {props.appConfigs && props.appConfigs.imgWelcome != "" &&
                                            <Flex.Item align="center" className="welcome">
                                                <Image src={props.appConfigs.imgWelcome} />
                                            </Flex.Item>
                                        }

                                        {props.appConfigs && props.appConfigs.imgWelcome == "" &&
                                            <Flex.Item align="center" className="welcome">
                                                <Image src="/images/welcome.svg" />
                                            </Flex.Item>
                                        }
                                    </Flex>

                                    <Flex gap="gap.medium" column>
                                        <Flex gap="gap.smaller">
                                            <Text
                                                styles={{ marginRight: '0.4rem !important' }}
                                                weight="light"
                                                size="medium"
                                                content={
                                                    <React.Fragment>
                                                        <div>{localize("VoceEsta")}: <span style={{ fontWeight: 'bold' }}>{props.meetingData.name}</span></div>
                                                    </React.Fragment>}
                                            />
                                        </Flex>

                                        {props.meetingData.descricao &&
                                            <Flex gap="gap.smaller">
                                                <Text
                                                    styles={{ marginRight: '0.4rem !important', whiteSpace: 'pre-line' }}
                                                    weight="light" size="medium"
                                                    content={props.meetingData.descricao}
                                                />
                                            </Flex>
                                        }

                                        {(props.meetingData.horarioAtendimentoDias != "" &&
                                            props.meetingData.horarioAtendimentoFinal != "" &&
                                            props.meetingData.horarioAtendimentoInicial != "") &&
                                            <Flex gap="gap.smaller" inline>
                                                <Text
                                                    styles={{ marginRight: '0.4rem !important' }}
                                                    weight="light"
                                                    size="medium"
                                                    content={
                                                        <React.Fragment>
                                                            <div>{localize("NossoHorario")}&nbsp;
                                                                <span style={{ fontWeight: 'bold' }}>
                                                                    {props.daysOfWeekLocale(props.meetingData.horarioAtendimentoDias)}, {localize("Das")} {props.meetingData.horarioAtendimentoInicial} {localize("Ate")} {props.meetingData.horarioAtendimentoFinal}
                                                                    &nbsp;{localize("HorarioBrasilia")}.
                                                                </span>
                                                            </div>
                                                        </React.Fragment>
                                                    } />
                                            </Flex>
                                        }

                                        <Flex gap="gap.smaller" column>
                                            <Text styles={{ marginBottom: '0px !important' }} weight="light" size="medium" content={localize("VamosLa")} />
                                            <Text weight="light" size="medium" content={localize("FavorAguarde")} />
                                        </Flex>
                                    </Flex>

                                    <Flex gap="gap.small">
                                        <button hidden={props.loggedIn} onClick={() => props.getAuthUrl()} className="br-sign-in small primary mt-3 mt-sm-0 ml-sm-3" style={{ fontSize: "14px" }} type="button">
                                            <i style={{ fontSize: "14px" }} className="fas fa-user" aria-hidden="true"></i>Entrar com&nbsp;<span className="text-black">gov.br</span>
                                        </button>

                                        {props.appSettings && props.appSettings.ajudaComoFunciona &&
                                            <Button content={localize("ComoFunciona")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaComoFunciona), "_blank")} />
                                        }

                                        {props.appSettings && props.appSettings.ajudaPerguntasFrequentes &&
                                            <Button content={localize("PerguntasFrequentes")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaPerguntasFrequentes), "_blank")} />
                                        }
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }

            {(props.loggedIn && props.userProfile) &&
                <Flex gap="gap.large" styles={{ margin: "4rem 0" }}>
                    <Avatar hidden={props.botWriting} icon={<Image src="/images/logo.png" />} />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting}
                            className="dialog1"
                            color="brand"
                            content={
                                <Flex>
                                    <Flex gap="gap.medium" column>
                                        <Flex gap="gap.smaller" vAlign="center">
                                            <Image styles={{ height: "2rem" }} src="/images/gov-br.svg" />
                                            <Text size="medium" content={`Autenticado com sucesso no gov.br.`} />
                                        </Flex>

                                        <Flex gap="gap.smaller" vAlign="center">
                                            {props.userProfile?.userPhoto &&
                                                <Avatar image={`data:image/jpeg;base64,${props.userProfile.userPhoto}`} />
                                            }

                                            {props.userProfile?.userPhoto == null &&
                                                <Flex gap="gap.smaller">
                                                    <Avatar size="small" name={props.userProfile?.userName} />
                                                </Flex>
                                            }

                                            <Text weight="bold" size="medium" content={props.userProfile.userName} />
                                            <Text size="medium" content={`entrou na fila de atendimento.`} />
                                            <button onClick={() => props.logout()} className="br-sign-in small primary mt-3 mt-sm-0 ml-sm-3" style={{ fontSize: "14px" }} type="button">
                                                <i style={{ fontSize: "14px" }} className="fas fa-user" aria-hidden="true"></i>Logoff&nbsp;<span className="text-black">gov.br</span>
                                            </button>
                                        </Flex>
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }

            {(!props.loggedIn && props.meetingData.bookingsUrl && !props.meetingQueueData.bookingsId && !props.meetingQueueData?.Schedule) &&
                <Flex gap="gap.large" styles={{ margin: "4rem 0" }}>
                    <Avatar hidden={props.botWriting} icon={<Image src="/images/logo.png" />} />
                    <Flex.Item grow>
                        <Segment
                            hidden={props.botWriting}
                            className="dialog2"
                            color="brand"
                            content={
                                <Flex gap="gap.large" column>
                                    <Text weight="bold" size="large" content={localize("Agendamento")} />

                                    <Flex gap="gap.smaller" column>
                                        {props.appConfigs && props.appConfigs.agendamentoQueueText == "" &&
                                            <Text weight="light" size="medium" content={localize("AgendamentoDescricao")} />
                                        }

                                        {props.appConfigs && props.appConfigs.agendamentoQueueText != "" &&
                                            <Text weight="light" size="medium" content={props.appConfigs.agendamentoQueueText} />
                                        }

                                        <Button content={localize("FazerAgendamento")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.meetingData.bookingsUrl), "_blank")} />
                                    </Flex>
                                </Flex>
                            }
                        />
                    </Flex.Item>
                </Flex>
            }

        </React.Fragment>
    );
};

const queueWelcomeWithTranslation = withTranslation()(QueueWelcomeCard);
export default queueWelcomeWithTranslation;